<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryForm" :label-position="labelPosition" label-width="100px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="流程名称">
                <el-input class="handle-input" v-model="queryCondition['name']" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button type="primary" @click="queryData">搜索</el-button>
              <el-button type="primary" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" border highlight-current-row>
        <el-table-column prop="id" label="流程ID"></el-table-column>
        <el-table-column prop="id" label="流程KEY"></el-table-column>
        <el-table-column prop="name" label="流程名称"></el-table-column>
        <el-table-column prop="userDepartment" label="状态"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <el-button size="mini" type="primary" @click="deploy(scope.row.id)">部署</el-button>
                        <el-button size="mini" type="primary" @click="del(scope.row.id)">删除</el-button>
                        <el-button size="mini" type="primary" @click="exp(scope.row.id)">导出xml</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination :page-sizes="[10,15,50,100]" @size-change="handleSizeChange" :page-size="queryCondition.size" :current-page="queryCondition.page + 1" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>
    <el-dialog title="编辑用户" :visible="userDialog" class="user-dialog">
      <el-form :model="userForm" :label-position="labelPosition" label-width="80px">
        <el-form-item label="用户名">
          <el-input class="dialog-input" disabled v-model="userForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户Code">
          <el-input class="dialog-input" disabled v-model="userForm.login" clearable></el-input>
        </el-form-item>
        <el-form-item label="节点权限">
          <el-transfer class="dialog-input" :props="routeObj" :titles="['Source', 'Target']" v-model="userRouteNodes" :data="routeNodes"></el-transfer>
        </el-form-item>
        <el-form-item label="角色">
          <el-table ref="roleTable" height="350" class="dialog-input" :data="authorities.filter(data => !this.authSearch || data.name.toLowerCase().includes(this.authSearch.toLowerCase()))" border highlight-current-row @selection-change="authChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name">
              <template slot="header" slot-scope="scope">
                <el-input v-model="authSearch" placeholder="输入关键字搜索"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="userDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveUser">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { activiti_interface } from "../../../../api/system/activiti";
import { roleService } from "../../../../api/user-manage/role";
import { Message } from "element-ui";
export default {
  name: 'user-manage',
  data() {
    return {
      tableData: [],
      total: 0,
      labelPosition: 'right',
      queryCondition: {
        name: '',
        page: 0,
        size: 15,
      },
      userDialog: false,
      userForm: {
        id: '',
        name: '',
        login: '',
        routeNodes: [],
        authorities: []
      },
      routeNodes: [],
      userRouteNodes: [],
      authorities: [],
      userAuthorities: [],
      authSearch: '',
      routeObj: {
        key: 'routeNodeId',
        label: 'routeNodeName'
      }
    }
  },
  created() {
    this.queryData();
  },
  methods: {
    queryData() {
      activiti_interface.getDeployments(this.queryCondition).then((res) => {
        this.tableData = res.data;
        this.total = res.total;
      });
    },
    deploy(id) {
      activiti_interface.deploy(id).then(res => {
        console.log(res);
      })
    },
    /**
     * 翻页事件
     */
    handleCurrentChange(val) {
      this.queryCondition.page = val - 1;
      this.queryData();
    },
    createModel() {
      window.open("/adminconsole/activiti/service/create");
    },
    /**
     * 每页条数更新事件
     * @param val
     */
    handleSizeChange(val) {
      this.queryCondition.size = val;
      this.queryData();
    },
    /**
     * 多选
     * @param val
     */
    authChange(val) {
      this.userForm.authorities = val;
    },
    /**
     * 获取所有节点
     */
    getRouteNodeList() {
      user_interface.getRouteNodeList().then((res) => {
        this.routeNodes = res;
      });
    },
    /**
     * 获取所有角色
     * @param authorities
     */
    getRoleData(authorities) {
      roleService.getRoleData({
        page: 0,
        size: 99999
      }).then((res) => {
        this.authorities = res.content;
        // 设置初始选中时，直接设置无效，需要在外部添加nextTick
        this.$nextTick(function () {
          this.authorities.forEach((auth) => {
            authorities.forEach((userAuth) => {
              if (auth.id == userAuth.id) {
                this.$refs.roleTable.toggleRowSelection(auth, true);
              }
            })
          });
        });
      });
    },
    /**
     * 保存用户信息
     */
    saveUser() {
      let routeArray = [];
      this.userRouteNodes.forEach((id) => {
        routeArray.push({ routeNodeId: id });
      });
      this.userForm.routeNodes = routeArray;
      roleService.updateUser(this.userForm).then((res) => {
        if (res.status == 200) {
          Message.success({
            message: '操作成功！',
            duration: 1000
          });
        } else {
          Message.error({
            message: '操作失败！',
            duration: 1000
          });
        }
        this.userDialog = false;
        this.queryData();
      });
    },
    resetForm() {
      this.$refs['queryForm'].resetFields();
    }
  }
}
</script>
<style scoped>
.handle-input {
  width: 95%;
}
.dialog-input {
  width: 85%;
}
.user-dialog >>> .el-dialog__body {
  max-height: 450px;
  overflow: auto;
}
</style>
